<template>
  <div>
  <SpeedInsights/>
  <Analytics/>
  <!--UiHeader :class="{ hidden: cookieFree }"/-->
  <UiHeader/>
  <GridOverlay v-if="isDevelopment" />
  <div>
    <NuxtPage />
  </div>
  <UiCookieConsent v-if="!cookieFree"/>
  <UiFooter/>
</div>
</template>


<script setup>
import { SpeedInsights } from "@vercel/speed-insights/nuxt";
import { Analytics } from '@vercel/analytics/nuxt';
import { useRouter} from 'vue-router';
import { useRoute } from 'vue-router';

import { computed } from 'vue';


import { useCartStore } from '@/stores/cartStore';

const router = useRouter();
const route = useRoute();

const GridOverlay = defineAsyncComponent(() => import('@/components/GridOverlay.vue'));
const UiHeader = defineAsyncComponent(() => import('@/components/ui/Header.vue'));
const UiFooter = defineAsyncComponent(() => import('@/components/ui/Footer.vue'));
const UiCookieConsent = defineAsyncComponent(() => import('@/components/ui/CookieConsent.vue'));


const cartStore = useCartStore();

const colorMode = useColorMode()
colorMode.value = 'light'; 
onMounted(async() => {
  console.log("%c v4.0.3 Made by Hjärtat - https://hjartat.net", "background: #000; color: #fff; display: block; padding:5px; padding-right: 10px;");
  console.log("%c If someone tells you that you have enough wheels and you don't need more, stop talking to them. You don't need that kind of negativitiy in your life.", "background: #e0307f; color: #d2d000; display: block; padding:5px; padding-right: 10px;");  
 
  //await cartStore.initCart();
  //save cart to local storage
  //localStorage.setItem('cartId', cartStore.cart.id);

  window.navigateToPage = navigateToPage;
  window.applyCode = applyCode;
});

const navigateToPage = (theroute) => {
  router.push(theroute);
}

const applyCode = async (code) => {
  try {
    console.log('applyCode called');
    const { success, error } = await cartStore.applyDiscountCode(code);
    if (success) {
      // Visa lyckat-meddelande
      console.log(success.message || 'Discount code applied successfully!');
    } else {
      // Visa error.value eller error-meddelande
      console.log(error?.value || 'Failed to apply discount code.');
    }
  } catch (error) {
    console.error('Error applying discount code:', error);
  }
};


const isDevelopment = computed(() => process.env.NODE_ENV === 'development');

const cookieFree = computed(() => route.query.cookiefree === 'true' || route.path.startsWith('/account'));


useDefaultSeo(); // Set default SEO & Schema for the app

</script>
